import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZUpdateDevicePollingApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface UpdateDevicePollingPutRequest {
  id: string
  isPollingEnabled?: boolean
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateDevicePollingApiResponse,
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type UpdateDevicePollingApiResponse = z.infer<typeof ZUpdateDevicePollingApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateDevicePolling (
  updateDevicePollingPutRequest: UpdateDevicePollingPutRequest,
  onSuccess: (successResponse: UpdateDevicePollingApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/assetrest//api/v2/udp/tiq/assets/polling-enabled/${updateDevicePollingPutRequest.id}`

  interceptedAxios
    .patch(url, { isPollingEnabled: updateDevicePollingPutRequest.isPollingEnabled }, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.http_status === 200) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
